import { render, staticRenderFns } from "./UnitShortcuts.vue?vue&type=template&id=29039f48"
import script from "./UnitShortcuts.vue?vue&type=script&lang=js"
export * from "./UnitShortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports